import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import sectionbg from "../assets/images/section-bg.jpg";
import nhsst2021 from "../assets/images/nhsst2021.png";
import { HashLink as Link } from "react-router-hash-link";
import Scroll from "../components/Scroll";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  link: {},
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
  },
  flex: {
    display: "flex",
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    textAlign: "left",
  },
  element: {
    padding: theme.spacing(2),
    textAlign: "left",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  backgroundSection: {
    backgroundImage: sectionbg,
  },
  anchortop: {
    display: "block",
    position: "relative",
    top: "-115px",
    visibility: "hidden",
  },
  anchor: {
    display: "block",
    position: "relative",
    top: "-90px",
    visibility: "hidden",
  },
}));

export default function Competitions() {
  const classes = useStyles();
  const links = [
    { name: "Rules", link: "#rules" },
    { name: "Topics", link: "#topics" },
    { name: "Format", link: "#format" },
    { name: "Schedule", link: "#schedule" },
    { name: "Results", link: "#results" },
  ];

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Scroll showBelow={250} />
      <Grid container>
        <Grid item md={2} xs={12}>
          <Paper className={classes.paper}>
            <Typography
              variant="subtitle1"
              gutterBottom
              style={{ textAlign: "center" }}
            >
              <b>Table of Contents</b>
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              1&nbsp;
              <Link className="about" to="#nhsst">
                NHSST
              </Link>
            </Typography>
            {links.map((item, index) => (
              <Typography variant="subtitle1" gutterBottom key={index}>
                &ensp;1.{index + 1}&nbsp;
                <Link className="about" to={item.link}>
                  {item.name}
                </Link>
              </Typography>
            ))}
          </Paper>
        </Grid>
        <Grid item md={10} xs={12}>
          <div className={classes.element}>
            <div className={classes.anchortop} id="nhsst" />
            <Grid container>
              <Grid item xs={12} md={7} lg={9}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div className={classes.flex} />
                  <Typography variant="h4" component="h2" gutterBottom>
                    <b>National High School Science Tournament 2021</b>
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    style={{ height: "auto", justifyContent: "center" }}
                  >
                    The <b>National High School Science Tournament (NHSST)</b>{" "}
                    is a Quizbowl-style science competition where teams of four
                    students race to buzz first on clues of decreasing
                    difficulty about concepts from physics, math, chemistry,
                    biology, astronomy, earth science, computer science, and
                    more. <br /> <br />
                    If you have any questions or concerns, please email us at{" "}
                    <a href="mailto:nhssciencetournament@gmail.com">
                      nhssciencetournament@gmail.com.
                    </a>
                  </Typography>
                  <div className={classes.flex} />
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                lg={3}
                style={{ alignItems: "center", textAlign: "center" }}
              >
                <img
                  alt="NHSST 2021"
                  src={nhsst2021}
                  style={{ padding: "10px", width: "65%" }}
                />
              </Grid>
            </Grid>
          </div>
          <div className={classes.element}>
            <div className={classes.anchor} id="rules" />
            <Typography variant="h5" component="h2" gutterBottom>
              <b>Rules</b>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              These rules are current as of July 21, 2021.
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              <b>Teams</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  Teams may have 3-6 players, 4 of which will play at a time.
                  Teams with under 3 players by August 5, 2021 will be dropped.
                </li>
                <li>
                  Team members must have been in grades 8-12 in the 2020-21
                  school year but do not necessarily need to have attended the
                  same school.
                </li>
                <li>
                  Teams that provide a moderator via this{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://docs.google.com/forms/d/e/1FAIpQLSe78u8tIto875QBKaY3HRMWI-ocHbgahBucnhsya-YaBNfl6w/viewform"
                  >
                    form
                  </a>{" "}
                  may be given precedence should the field become full.
                </li>
              </ul>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              <b>Setup</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  The competition will take place over Discord, where teams will
                  be assigned roles and sent to their respective voice channels
                  for each round.
                </li>
                <li>
                  Each round will take place in a voice channel with two teams
                  and a moderator who will read the questions and keep score.
                </li>
                <li>
                  All players should have cameras on while questions are being
                  read and have one hand in view at all times.
                </li>
              </ul>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <b>Rounds</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  Each round will consist of two types of questions: tossups and
                  bonuses.
                </li>
                <li>
                  A round consists of 20 <b>tossup questions</b>.
                  <ul>
                    <li>
                      Tossups are pyramidal questions with clues of decreasing
                      difficulty. All players may buzz on tossup questions.
                    </li>
                    <li>
                      When a player buzzes, they will be recognized by the
                      moderator and has 3 seconds to finish their answer. Powers
                      (answering the question correctly on one of the first few
                      clues) will receive 15 points while correct answers after
                      the power mark will receive 10 points. Incorrect answers
                      before the question has been read will result in a loss of
                      5 points.
                    </li>
                    <li>
                      Team members may not discuss during tossup questions and
                      only one player from each team may buzz on a given tossup.
                    </li>
                    <li>
                      Competitors may buzz in within 5 seconds of the moderator
                      finishing a tossup question.
                    </li>
                  </ul>
                </li>
                <li>
                  Teams that correctly answer a tossup question will receive a{" "}
                  <b>bonus question.</b>
                  <ul>
                    <li>
                      <b>Bonus questions</b> are 3-part questions that are read
                      to a team after they correctly answer the corresponding
                      tossup question.
                    </li>
                    <li>
                      Each bonus consists of an easy, medium, and hard part (not
                      necessarily in that order), each worth 10 points.
                    </li>
                    <li>
                      Team members may discuss during bonus questions and must
                      direct an answer within 5 seconds of the moderator
                      finishing the question by capitalizing it in the chat or
                      verbally indicating that it is their final answer.
                    </li>
                  </ul>
                </li>
              </ul>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <b>Miscellaneous</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  Teams may choose to protest a question if they deem its
                  content to be inaccurate or the moderator’s ruling on their
                  answer to be unfair. Protests will only be considered if they
                  affect the overall result of the round. Excessive protests may
                  be denied at the moderator's discretion.
                </li>
                <li>
                  Because of latency, different people may see different orders
                  of buzzes on their screens, which affects which player has
                  buzzed first. The order on the moderator’s screen will be
                  taken as the official one in this case.
                </li>
              </ul>
            </Typography>
          </div>
          <div className={classes.element}>
            <div className={classes.anchor} id="topics" />
            <Typography variant="h5" component="h2" gutterBottom>
              <b>Topics</b>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              NHSST questions will cover several areas of science as in
              Quizbowl, but will consist of only science questions to give
              students interested in Science Bowl or the science aspect of
              Quizbowl a chance to show off their skills.
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  Each round will consist of a specific distribution of science
                  subjects, where the corresponding number represents the number
                  of tossup-bonus pairs for that subject in each round.
                  <ul>
                    <li>Physics (3)</li>
                    <li>Math (3)</li>
                    <li>Chemistry (3)</li>
                    <li>Biology (3)</li>
                    <li>Astronomy (2)</li>
                    <li>Earth Science (2)</li>
                    <li>Computer Science (1)</li>
                    <li>General Science (3)</li>
                  </ul>
                </li>
                <li>
                  Tossups and bonuses may be either computational or
                  theoretical. Computational questions will be preceded by the
                  words "Paper and pencil ready."
                </li>
                <li>
                  Question difficulty will be slightly harder than Quizbowl HS
                  Regs difficulty. Packets marked with a (2) on{" "}
                  <a href="https://quizbowlpackets.com/">quizbowlpackets.com</a>{" "}
                  are examples of HS Regs difficulty, and teams can practice by
                  reading the science questions from those packets.
                </li>
              </ul>
            </Typography>
          </div>
          <div className={classes.element}>
            <div className={classes.anchor} id="format" />
            <Typography variant="h5" component="h2" gutterBottom>
              <b>Format</b>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              The competition will consist of 5 preliminary rounds in the
              morning and 4 additional rounds in the afternoon for all teams,
              culminating in a final round between the top two teams. There will
              be a prize pool for top teams, but the exact amount will be
              announced closer to the date of the competition. The prize pool is
              at <b>$1000 as of April 5, 2021.</b>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              <b>Preliminaries</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  Teams will be randomly divided into round robin brackets.
                </li>
                <li>
                  Teams with the highest records in each bracket will be placed
                  into one of the playoff brackets.
                </li>
                <li>
                  Remaining teams will be placed into consolation brackets to
                  allow them to continue playing throughout the competition.
                </li>
              </ul>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <b>Afternoon rounds</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  All teams will continue playing in round robin brackets, with
                  teams in the playoff brackets eligible for finals.
                </li>
                <li>
                  The top 2 teams in the playoffs brackets will qualify for
                  finals, and a tiebreaker may be used to determine finalists.
                </li>
                <li>
                  Remaining teams will be placed into consolation brackets to
                  allow them to continue playing throughout the competition.
                </li>
              </ul>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <b>Finals</b>
            </Typography>
            <Typography
              variant="subtitle1"
              component="h2"
              gutterBottom
              style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  The top 2 teams will play against each other in an advantaged
                  final, where the team with the better record would need to
                  only win a single game while the other would have to win
                  twice.
                </li>
                <li>
                  A tiebreaker may be used to determine the third place team.
                </li>
                <li>All teams may spectate the finals.</li>
              </ul>
            </Typography>
            <Typography
                variant="subtitle1"
                component="h2"
                gutterBottom
                style={{ marginTop: "-20px" }}
            >
              <b>Prizes</b>
            </Typography>
            <Typography
                variant="subtitle1"
                component="h2"
                gutterBottom
                style={{ marginTop: "-20px" }}
            >
              <ul>
                <li>
                  The top 2 teams as well as the top 7 individuals will receives prizes. The third place team may receive prizes as well.
                </li>
                <li>
                  The prizes are: twelve $72 year-long Wolfram Alpha Notebook Edition subscriptions, four $25 AoPS coupons, and three $21 Maple Learn Premium codes.
                </li>
              </ul>
            </Typography>
          </div>
          <div className={classes.element}>
            <div className={classes.anchor} id="schedule" />
            <Typography variant="h5" component="h2" gutterBottom>
              <b>Schedule</b>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              The tournament will take place on August 8, 2021 from 8:30 a.m. to 5:30 p.m. PDT. This schedule is tentative and subject to change depending on how smoothly things run, but the tournament structure will remain the same.
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              <b>Opening meeting — </b>8:30 a.m.
              <br />
              <b>Morning rounds begin — </b>9:00 a.m.
              <br />
              <b>Lunch — </b>11:30 a.m.
              <br />
              <b>Afternoon rounds begin — </b>12:30 p.m.
              <br />
              <b>Single elimination rounds begin — </b>4:00 p.m.
              <br />
              <b>Awards — </b>5:00 p.m.
              <br />
            </Typography>
          </div>
          <div className={classes.element}>
            <div className={classes.anchor} id="results" />
            <Typography variant="h5" component="h2" gutterBottom>
              <b>Results</b>
            </Typography>
            <Typography variant="subtitle1" component="h2" gutterBottom>
              Competition results will be posted soon after the competition
              takes place, including overall scores and records and detailed
              statistics for both teams and individuals. Moderators will be
              keeping track of individual performance so students can see how
              they stack up against their peers.
            </Typography>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
}
